// extracted by mini-css-extract-plugin
export default {"marginTop":"ProductLoadingError_marginTop__KL23x","errorBox":"ProductLoadingError_errorBox__QfLXZ","link":"ProductLoadingError_link__Ah2ax"};